import * as React from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Avatar, Box, IconButton, List, ListItem, ListItemAvatar, ListItemText, TextField } from '@mui/material';
import { Empty } from 'antd';
import { ArrowRightRounded, Search, WebRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ListeMenuSearchFr from "../Data/ListeMenuSearchFr.json";
import ListeMenuSearchEn from "../Data/ListeMenuSearchEn.json";
import { Link } from 'react-router-dom';

export default function SearchPage() {
    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');
    const { t, i18n } = useTranslation();
    const [data, setData] = React.useState(i18n.language === "en" ? ListeMenuSearchEn : ListeMenuSearchFr)

    const handleClickOpen = (scrollType: DialogProps['scroll']) => () => {
        setOpen(true);
        setData(i18n.language === "en" ? ListeMenuSearchEn : ListeMenuSearchFr)
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef<HTMLElement>(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    React.useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
                e.preventDefault();
                handleClickOpen('paper')();
            }
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    });

    function handleChange(e: any) {
        setData((i18n.language === "en" ? ListeMenuSearchEn : ListeMenuSearchFr).filter((search: any) => search.title.toUpperCase().includes(e.target.value.toUpperCase()) || search.description.toUpperCase().includes(e.target.value.toUpperCase()) || search.dictionnaire.toUpperCase().includes(e.target.value.toUpperCase())))
    }

    return (
        <React.Fragment>
            {/* <IconButton onClick={handleClickOpen('paper')} size='small' style={{ border: "1px solid", left: "5%" }} color='info'><Search /></IconButton> */}

            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <button className='ibg-search-trigger' onClick={handleClickOpen('paper')}><Search /><span>{t("recherche")}</span><kbd>⌘K</kbd></button>
            </Box>
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <IconButton aria-label={t("recherche")} onClick={handleClickOpen('paper')}><Search /></IconButton>
            </Box>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullWidth
                
            >
                <DialogTitle className='ibg-search__head' id="scroll-dialog-title">
                    <Box gap={2} display={"flex"} alignItems={"center"}>
                        <Search className='ibg-search__icon' />
                        <TextField autoFocus type='search' onChange={handleChange} size='medium' placeholder={t("placeholder")} fullWidth variant='standard' InputProps={{ disableUnderline: true }} />
                        <button className='ibg-search__esc' onClick={handleClose}>esc</button>
                    </Box>
                </DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                    >
                        {
                            data.length !== 0 ?
                                <List>
                                    {data.map((tt: any, i: number) => {
                                        const item = (
                                            <ListItem className='list' alignItems="flex-start">
                                                <ListItemAvatar>
                                                    <Avatar className='ibg-search__avatar' alt=""><WebRounded /></Avatar>
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={t(tt.title)}
                                                    secondary={
                                                        <React.Fragment>
                                                            {tt.description}
                                                        </React.Fragment>
                                                    }
                                                />
                                                <ArrowRightRounded style={{ marginTop: "15px" }} />
                                            </ListItem>
                                        );
                                        return tt.url.startsWith('http') ? (
                                            <a key={i} className='lien' href={tt.url} target="_blank" rel="noopener noreferrer">{item}<br /></a>
                                        ) : (
                                            <Link key={i} className='lien' to={tt.url}>{item}<br /></Link>
                                        );
                                    })}
                                </List>
                                :
                                <Empty />
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions className='ibg-search__foot' >
                    <span>IBG Alpha Technology · {t("copyright")}</span>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}